import React, { useContext } from "react";
import { MemoContext } from "../contexts/MemoContext";
import axios from "axios";

const FavIcon = ({ fav, showFav, mid }) => {
  const { fetchMemo } = useContext(MemoContext);
  const handleFav = (event) => {
    event.stopPropagation();
    if (fav === 1) {
      axios
        .post(`/memos/fav/${mid}`, { fav: 0 })
        .then(() => {
          fetchMemo();
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      axios
        .post(`/memos/fav/${mid}`, { fav: 1 })
        .then(() => {
          fetchMemo();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  return (
    <div
      className={`${showFav || fav ? "block" : "hidden"}`}
      onClick={handleFav}
    >
      {!fav ? (
        <svg
          className='text-red-400 w-5 cursor-pointer fav-svg'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z'
          />
        </svg>
      ) : (
        <svg
          className='text-red-400 w-5 cursor-pointer'
          fill='currentColor'
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            d='M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z'
            clipRule='evenodd'
          />
        </svg>
      )}
    </div>
  );
};

export default FavIcon;
